<template>
  <panel class="mgb10">
    <el-form ref="produceForm" :model="produceForm" label-width="0">
      <el-form-item
        :prop="'workerSerialNo'"
        :rules="[
          {
            required: true,
            message: $t('rules.required', [$t('worker.serialNo')]),
            trigger: 'blur',
          },
        ]"
      >
        <el-input
          placeholder="工号"
          v-model.trim="produceForm.workerSerialNo"
          @keypress.enter.native="workerSnEnterKeyUp('workOrderSn')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :prop="'phaseId'"
        :rules="[
          {
            required: true,
            message: $t('rules.required', [$t('menu.phases')]),
            trigger: 'blur',
          },
        ]"
      >
        <el-select
          v-model="produceForm.phaseId"
          placeholder="选择工序"
          class="block"
          clearable
          filterable
        >
          <el-option
            v-for="item in workerPhases"
            :key="item.phaseId"
            :label="item.phaseName"
            :value="item.phaseId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :prop="'_workOrderSerialNos'"
        :rules="[
          {
            required: true,
            message: $t('rules.required', [$t('text.serialNo')]),
            trigger: 'blur',
          },
        ]"
      >
        <el-input
          id="workOrderSn"
          type="textarea"
          v-model="produceForm._workOrderSerialNos"
          :rows="4"
          placeholder="一行一个工单号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="produceSubmit"
          :loading="scanSubmitDing"
          class="block"
        >
          提交
        </el-button>
      </el-form-item>
    </el-form>
  </panel>
</template>

<script>
import { page } from "@/utils/mixins.js";

import Worker from "@/api/worker.js";
import WorkOrder from "@/api/workOrder.js";
import Util from "@/utils";

export default {
  mixins: [page],
  data() {
    return {
      produceForm: {
        workerSerialNo: null,
        phaseId: null,
        serialNos: [],
        _workOrderSerialNos: null,
      },
      worker: null,
      workerPhases: [],
      scanSubmitDing: false,
    };
  },
  methods: {
    workerSnEnterKeyUp(type) {
      const self = this;
      if (
        self.produceForm.workerSerialNo == null ||
        self.produceForm.workerSerialNo == ""
      ) {
        self.$message({ message: "请先扫描工号", type: "warning" });
        return;
      }

      self.worker = null;
      self.produceForm.phaseId = null;
      self.produceForm._workOrderSerialNos = null;
      self.workerPhases = [];
      Worker.findBySerialNo({
        serialNo: self.produceForm.workerSerialNo,
      }).then(function (res) {
        if (res.data.code === 200) {
          self.worker = res.data.entity;
          self.workerPhases = res.data.entity.workerPhases;
          if (self.workerPhases.length == 1) {
            self.produceForm.phaseId = self.workerPhases[0].phaseId;
          }
          document.getElementById(type).focus();
        } else {
          self.workerExist = false;
          self.$message({ message: "该工人不存在", type: "warning" });
        }
      });
    },

    produceSubmit() {
      const self = this;
      self.resultsDF = false;
      self.$refs.produceForm.validate((valid) => {
        if (valid) {
          this.produceForm.serialNos = this.produceForm._workOrderSerialNos
            .split("\n")
            .map(function (sn) {
              return sn.trim();
            })
            .filter(function (sn) {
              return sn !== "";
            });
          this.produceForm.phaseName = self.workerPhases.find(
            (p) => p.phaseId === this.produceForm.phaseId
          ).phaseName;
          self.scanSubmitDing = true;
          WorkOrder.batchScanStart(self.produceForm).then(function (res) {
            if (res.status == 200) {
              self.sysResults(res.data, self.$t("prompt.startSuccess"));
              self.scanSubmitDing = false;
              self.worker = null;
              self.produceForm.workerSerialNo = null;
              self.produceForm.phaseId = null;
              self.produceForm._workOrderSerialNos = null;
              self.workerPhases = [];
            } else {
              self.sysError();
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
</style>